<template>
  <div>
    <form class="login" @submit.prevent="register">
      <h3 class="text-blue">{{ $_t('KW:register') }}</h3>

      <div class="alert alert-danger" v-if="errors">
        <ul class="list-unstyled mb-0">
          <li v-for="error in errors">{{ error[0] }}</li>
        </ul>
      </div>
      <div class="row">
        <b-input-group div class="col-12 mt-2">
          <b-form-input id="fullname" type="text" v-model="form.fullname" required :placeholder="$_t('KW:fullName')" />
        </b-input-group>
        <b-input-group div class="col-12 mt-2">
          <b-form-input id="email" type="email" v-model="form.email" required :placeholder="$_t('KW:email')" />
        </b-input-group>
        <b-input-group div class="col-12 mt-2">
          <div class="d-inline-block w-35" v-if="userCountry">
            <v-select class="select-filter h-100" v-model="userCountry" label="name" :options="countries" :clearable="false">
              <template slot="selected-option" slot-scope="{ phonecode }">+{{ phonecode }}</template>
            </v-select>
          </div>
          <b-form-input id="phone" type="number" v-model="form.phone" required :placeholder="$_t('KW:phoneNumber')" />
        </b-input-group>

        <div class="input-group col-12 mt-2">
          <div class="text-sm text-muted">{{ $t('KW:registerPhoneFieldDescription') }}</div>
        </div>

        <div class="input-group col-12 mt-2">
          <button :disabled="submitDisabled" class="btn" type="submit">{{ $_t('KW:register') }}</button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import VueSelect from 'vue-select';

export default {
  components: {
    vSelect: VueSelect,
  },
  props: ['userCountry', 'countries'],
  data: function () {
    return {
      errors: false,
      submitDisabled: false,
      form: {
        fullname: '',
        phone: '',
        email: '',
      },
    };
  },

  methods: {
    register: function () {
      this.errors = false;
      this.submitDisabled = false;
      let form = this.form;
      form.country_id = this.userCountry.id;
      form.registered_via = 'web';
      this.$store
        .dispatch('auth/register', this.form)
        .then(() => {
          this.$emit('show-verify-section');
        })
        .catch(error => (this.errors = error.response.data.error))
        .finally(() => (this.submitDisabled = false));
    },
  },
};
</script>
<style lang="scss" scoped>
.input-group {
  .input-group-prepend .input-group-text {
    background: $dark-blue;
    border-color: $dark-blue;
    color: $white;
  }
  input {
    color: $dark-blue;
  }
}
button {
  background-color: $secondary;
  border: none;
  color: $dark-blue;
  border-radius: 20px;
  padding: 8px 15px;
}
</style>